import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {
  BASE_CONFIG
} from '@/config/config'
//import {InterfaceService} from '@/services/api'

Vue.use(Vuex);
const state = {
  allowBack: true,
  userInfo: null, // 用户信息
  isLogin: '0',
  systemModules: [],
  applicationDataList:[],
  bussinessDataList:[],
  myToDoSearchBean: {},
  isFromLogin:false,
  tenthAnniversaryQuestionList: []

}

const mutations = {
  initAjax(state, param) {
    
    // axios.get(BASE_CONFIG.OSS_SERVICE_ADDRESS+'/HK_HOME/systeModules.json')
    //   .then(response => {
    //     if (response.status === 200) {

    //       let data = response.data
    //       if (typeof data === "string") {
    //         state.systemModules = eval("(" + data + ")");
    //       } else if (typeof data === "object") {
    //         state.systemModules = data
    //       }
    //       console.log(state.systemModules)
    //     }
    //   })
  },
  systemModules(state, param) {
    state.systemModules = param

  },
  setApplicationDataList(state, param) {
    state.applicationDataList = param

  },
  setBussinessDataList(state, param) {
    state.bussinessDataList = param

  },
  
  // 存储用户信息
  setUserInfo(state, data) {
    state.userInfo = data
    state.isLogin = data.isLogin || '0'
    //console.log(state.isLogin)
  },

  //我的待办查询信息
  setMyToDoSearchList(state, param) {
    state.myToDoSearchBean = param
  },  
  //是否来自登录页 控制调用弹层接口
  setIsFromLogin(state, param) {
    state.isFromLogin = param
  },
  setTenthAnniversaryQuestionListMap(state, data) {
    if(data) {
      sessionStorage.setItem("tenthAnniversaryQuestionList",JSON.stringify(data));
    }
    state.tenthAnniversaryQuestionList = data || [];
  }  
  
}

const actions = {
  initAjax({ commit }, data) {
    commit('initAjax');
  },
  setUserInfoAction({ commit }, data) {
    commit('setUserInfo', data);
  },
  systemModulesAction({ commit }, categoryList) {
        commit('systemModules', categoryList);
  },
  setApplicationDataListAction({ commit }, list) {
    commit('setApplicationDataList', list);
  },
  setBussinessDataListAction({ commit }, list) {
    commit('setBussinessDataList', list);
  },
  setMyToDoSearchAction({ commit }, data) {
    commit('setMyToDoSearchList', data);
  },  
  setIsFromLoginAction({ commit }, data) {
    commit('setIsFromLogin', data);
  },
  setTenthAnniversaryQuestionList({ commit }, data) {
    commit('setTenthAnniversaryQuestionListMap', data);
  }
}

export default new Vuex.Store({
  state,
  actions,
  mutations,
  modules: {

  }
})


// WEBPACK FOOTER //
// ./src/store/index.js